export const FEATURE_DECISION_KEYS = {
  // TODO: QUAR-1483 Clean up SPONSORED_AIRLINES_DRAWER_ENABLED once the ABC experiment is concluded
  ACORN_AD_FILTERING_LOGIC_DISABLED: 'ACORN_AD_FILTERING_LOGIC_DISABLED',
  ACORN_SEARCH_RESULTS_PAGE_ON_DIRECT_BP_LANDING: 'ACORN_SEARCH_RESULTS_PAGE_ON_DIRECT_BP_LANDING',
  ADS_DSA_MODAL_UPDATED_WITH_LEGAL_NAME_WEB: 'ADS_DSA_MODAL_UPDATED_WITH_LEGAL_NAME_WEB',
  AIRLINE_LOGOS_IN_RESULTS: 'AIRLINE_LOGOS_IN_RESULTS',
  ANONYMOUS_UTID_PROPAGATION_EXPLICIT_TLD_REDIRECT:
    'ANONYMOUS_UTID_PROPAGATION_EXPLICIT_TLD_REDIRECT',
  BOOKING_PANEL_WITHOUT_MODAL: 'BOOKING_PANEL_WITHOUT_MODAL',
  CAN_SEE_PACKAGES_WEBSITE: 'CAN_SEE_PACKAGES_WEBSITE',
  CARS_COPY_HEADER_TAB_ENABLED: 'CARS_COPY_HEADER_TAB_ENABLED',
  COLLAPSE_FLIGHT_PRICING_OPTIONS: 'COLLAPSE_FLIGHT_PRICING_OPTIONS',
  DISABLE_S2L_FOR_BAGGAGE_SEARCH: 'DISABLE_S2L_FOR_BAGGAGE_SEARCH',
  ENABLE_ACORN_GTM_INTEGRATION: 'EnableAcornGtmIntegration',
  ENABLE_ACORN_INLINE_SEO_CREATIVES: 'ENABLE_ACORN_INLINE_SEO_CREATIVES',
  ENABLE_ACORN_INLINE_TRAVEL_ENTITY: 'ENABLE_ACORN_INLINE_TRAVEL_ENTITY',
  ENABLE_AIRSPACE_CLOSURE_BANNER: 'ENABLE_AIRSPACE_CLOSURE_BANNER',
  ENABLE_AIRSPACE_CLOSURE_BANNER_LAYOVERS: 'ENABLE_AIRSPACE_CLOSURE_BANNER_LAYOVERS',
  ENABLE_ARGENTINA_BANNER: 'ENABLE_ARGENTINA_BANNER',
  ENABLE_BAGGAGE_FILTER_IN_SEARCH_RESULTS_DESKTOP:
    'ENABLE_BAGGAGE_FILTER_IN_SEARCH_RESULTS_DESKTOP',
  ENABLE_BAGGAGE_FILTER_IN_SEARCH_RESULTS_MWEB: 'ENABLE_BAGGAGE_FILTER_IN_SEARCH_RESULTS_MWEB',
  ENABLE_BAGGAGE_INCLUSION_ICONS: 'ENABLE_BAGGAGE_INCLUSION_ICONS',
  ENABLE_BAGGAGE_SELECT: 'ENABLE_BAGGAGE_SELECT',
  ENABLE_BANANA_GRAPPLER_TOPIC_FILTER_INTERACTION_TRIGGERED:
    'ENABLE_BANANA_GRAPPLER_TOPIC_FILTER_INTERACTION_TRIGGERED',
  ENABLE_BANANA_GTM_INTEGRATION: 'ENABLE_BANANA_GTM_INTEGRATION',
  ENABLE_BANANA_HEADER_G_C: 'ENABLE_BANANA_HEADER_G_C',
  ENABLE_BANANA_INLINE_ADS_DATA: 'ENABLE_BANANA_INLINE_ADS_DATA',
  ENABLE_BLUE_MINI_GRID: 'ENABLE_BLUE_MINI_GRID',
  ENABLE_BOOK_IT_FOR_ME: 'ENABLE_BOOK_IT_FOR_ME',
  ENABLE_CALENDAR_PRICES: 'ENABLE_CALENDAR_PRICES',
  ENABLE_CALENDAR_PRICES_PROGRESSIVE_LOADING_DESKTOP:
    'ENABLE_CALENDAR_PRICES_PROGRESSIVE_LOADING_DESKTOP',
  ENABLE_CALENDAR_PRICES_PROGRESSIVE_LOADING_MOBILE:
    'ENABLE_CALENDAR_PRICES_PROGRESSIVE_LOADING_MOBILE',
  ENABLE_CALENDAR_PRICES_V2_ENDPOINTS: 'ENABLE_CALENDAR_PRICES_V2_ENDPOINTS',
  ENABLE_CAR_HIRE_INDICATIVE_PRICE_IN_BOOKING_PANEL:
    'ENABLE_CAR_HIRE_INDICATIVE_PRICE_IN_BOOKING_PANEL',
  ENABLE_CITY_DRAWER_COUNTRY_VIEW: 'ENABLE_CITY_DRAWER_COUNTRY_VIEW',
  ENABLE_COMBINED_EXPLORE_ANYTIME_SEARCH: 'ENABLE_COMBINED_EXPLORE_ANYTIME_SEARCH',
  ENABLE_CONSENT_MANAGEMENT: 'ENABLE_CONSENT_MANAGEMENT',
  ENABLE_CRUISES_TAB: 'ENABLE_CRUISES_TAB',
  ENABLE_DESKTOP_BOOKING_PANEL: 'ENABLE_DESKTOP_BOOKING_PANEL',
  ENABLE_DESTINATION_GUIDEBOOK: 'ENABLE_DESTINATION_GUIDEBOOK',
  ENABLE_DOLPHINS_FLIGHT_FINDER: 'ENABLE_DOLPHINS_FLIGHT_FINDER',
  ENABLE_DOLPHINS_PRICING: 'ENABLE_DOLPHINS_PRICING',
  ENABLE_ENFORCE_TRIP_TYPE: 'ENABLE_ENFORCE_TRIP_TYPE',
  ENABLE_EXPANDABLE_PRICING_OPTION: 'ENABLE_EXPANDABLE_PRICING_OPTION',
  ENABLE_EXPLORE_AI: 'ENABLE_EXPLORE_AI',
  ENABLE_EXPLORE_BY_EXPERIENCE: 'ENABLE_EXPLORE_BY_EXPERIENCE',
  ENABLE_EXPLORE_COUNTRIES_FILTER_POC: 'ENABLE_EXPLORE_COUNTRIES_FILTER_POC',
  ENABLE_EXPLORE_DEAL_BADGES: 'ENABLE_EXPLORE_DEAL_BADGES', // enable fetch and calculation of price bands for deal badges
  ENABLE_EXPLORE_SPONSORED_CONTENT: 'ENABLE_EXPLORE_SPONSORED_CONTENT',
  ENABLE_FILTERED_DAY_VIEW: 'ENABLE_FILTERED_DAY_VIEW',
  ENABLE_FLEXIBLE_DATE_SELECTION_WITH_BACK_TO_DEPART:
    'ENABLE_FLEXIBLE_DATE_SELECTION_WITH_BACK_TO_DEPART',
  ENABLE_FLEXIBLE_DATE_SELECTION_WITH_STICK_TO_RETURN:
    'ENABLE_FLEXIBLE_DATE_SELECTION_WITH_STICK_TO_RETURN',
  ENABLE_FULL_SKELETON_RESULTS: 'ENABLE_FULL_SKELETON_RESULTS',
  ENABLE_GET_PRICE_ALERTS_TOGGLE_TEXT: 'ENABLE_GET_PRICE_ALERTS_TOGGLE_TEXT',
  ENABLE_GLOBAL_NAVIGATION: 'ENABLE_GLOBAL_NAVIGATION',
  ENABLE_GOOGLE_ONE_TAP: 'ENABLE_GOOGLE_ONE_TAP',
  ENABLE_GOOGLE_TAG_MANAGER: 'ENABLE_GOOGLE_TAG_MANAGER',
  ENABLE_GRAPHIC_PROMO: 'ENABLE_GRAPHIC_PROMO',
  ENABLE_HIDDEN_GEMS_NLS: 'ENABLE_HIDDEN_GEMS_NLS',
  ENABLE_HOMEPAGE_HERO: 'ENABLE_HOMEPAGE_HERO',
  ENABLE_HOMEPAGE_HERO_VIDEO: 'ENABLE_HOMEPAGE_HERO_VIDEO',
  ENABLE_HOTELS_INDICATIVE_PRICE_IN_BOOKING_PANEL:
    'ENABLE_HOTELS_INDICATIVE_PRICE_IN_BOOKING_PANEL',
  ENABLE_HOTELS_RECOMMENDATIONS_IN_BOOKING_PANEL: 'ENABLE_HOTELS_RECOMMENDATIONS_IN_BOOKING_PANEL',
  ENABLE_HOTELS_RECOMMENDATIONS_IN_RYANAIR_B_P: 'ENABLE_HOTELS_RECOMMENDATIONS_IN_RYANAIR_B_P',
  ENABLE_INDICATIVE_PRICING_ORDERING: 'ENABLE_INDICATIVE_PRICING_ORDERING',
  ENABLE_INLINE_HOTELS_ADS: 'ENABLE_INLINE_HOTELS_ADS',
  ENABLE_INTERNAL_LINKING: 'ENABLE_INTERNAL_LINKING',
  ENABLE_INTERNATIONAL_SITES: 'ENABLE_INTERNATIONAL_SITES',
  ENABLE_INVALID_JSON_RESPONSE_HANDLING: 'ENABLE_INVALID_JSON_RESPONSE_HANDLING',
  ENABLE_LOGIN_FORM_AUTO_PROMPT: 'ENABLE_LOGIN_FORM_AUTO_PROMPT',
  ENABLE_LOYALTY_DISCOUNTS: 'ENABLE_LOYALTY_DISCOUNTS',
  ENABLE_MEXICO_BANNER: 'ENABLE_MEXICO_BANNER',
  ENABLE_MOROCCO_RAMADAN_BANNER: 'ENABLE_MOROCCO_RAMADAN_BANNER',
  ENABLE_MULTICITY_ON_BANANA: 'ENABLE_MULTICITY_ON_BANANA',
  ENABLE_MULTICITY_SAVE: 'ENABLE_MULTICITY_SAVE',
  ENABLE_MULTIPLE_CARRIERS_FOR_UPSELL: 'ENABLE_MULTIPLE_CARRIERS_FOR_UPSELL',
  ENABLE_NEW_TRANSLATIONS_XSELL__B_P: 'ENABLE_NEW_TRANSLATIONS_XSELL__B_P',
  ENABLE_NEW_TRANSLATIONS_XSELL__B_P_MWEB: 'ENABLE_NEW_TRANSLATIONS_XSELL__B_P_MWEB',
  ENABLE_PACKAGES_PARALLEL_SEARCH_OPTION: 'ENABLE_PACKAGES_PARALLEL_SEARCH_OPTION',
  ENABLE_PACKAGES_UP_SELL: 'ENABLE_PACKAGES_UP_SELL',
  ENABLE_PARALLEL_SEARCH_MULTI_LINE: 'ENABLE_PARALLEL_SEARCH_MULTI_LINE',
  ENABLE_PARALLEL_SEARCH_OPTION: 'ENABLE_PARALLEL_SEARCH_OPTION',
  ENABLE_PARTNER_CARD_PRICING_REDESIGN: 'ENABLE_PARTNER_CARD_PRICING_REDESIGN',
  ENABLE_PERIMETER_X_FOR_BANANA: 'ENABLE_PERIMETER_X_FOR_BANANA',
  ENABLE_PQS_HOTEL_CARD_NEW_STYLE: 'ENABLE_PQS_HOTEL_CARD_NEW_STYLE',
  ENABLE_PQS_HOTEL_LIST_ON_MWEB: 'ENABLE_PQS_HOTEL_LIST_ON_MWEB',
  ENABLE_PQS_SUMMARY: 'ENABLE_PQS_SUMMARY',
  ENABLE_PRERENDER: 'ENABLE_PRERENDER',
  ENABLE_PRICE_ALERTS_TOGGLE_SAVE_TEXT: 'ENABLE_PRICE_ALERTS_TOGGLE_SAVE_TEXT',
  ENABLE_PRICE_ALERT_SIGNUP_ON_MWEB: 'ENABLE_PRICE_ALERT_SIGNUP_ON_MWEB',
  ENABLE_PRICE_ALERT_TOGGLE: 'ENABLE_PRICE_ALERT_TOGGLE',
  ENABLE_PRICE_BANDS_DYNAMIC_FILTERING: 'ENABLE_PRICE_BANDS_DYNAMIC_FILTERING',
  ENABLE_PRICE_BANDS_EMPTY_LOADING_STATE: 'ENABLE_PRICE_BANDS_EMPTY_LOADING_STATE',
  ENABLE_PRICE_BANDS_FLIGHT_SEARCH_RESULTS: 'ENABLE_PRICE_BANDS_FLIGHT_SEARCH_RESULTS',
  ENABLE_PRICE_BANDS_MESSAGE_LOADING_STATE: 'ENABLE_PRICE_BANDS_MESSAGE_LOADING_STATE',
  ENABLE_PRICE_BANDS_STATIC_FILTERING: 'ENABLE_PRICE_BANDS_STATIC_FILTERING',
  ENABLE_PRICE_GUARANTEE: 'ENABLE_PRICE_GUARANTEE',
  ENABLE_PRICE_REFRESH: 'ENABLE_PRICE_REFRESH',
  ENABLE_PSS_UI_REFRESH: 'ENABLE_PSS_UI_REFRESH',
  ENABLE_RAIL: 'ENABLE_RAIL',
  ENABLE_RANKING_EXPLANATION_WRAPPER: 'ENABLE_RANKING_EXPLANATION_WRAPPER',
  ENABLE_RELEVANT_DIGITAL_AS_PREBID_PROVIDER: 'ENABLE_RELEVANT_DIGITAL_AS_PREBID_PROVIDER',
  ENABLE_RUSSIA_BANNER: 'ENABLE_RUSSIA_BANNER',
  ENABLE_SAVE_TO_LIST: 'ENABLE_SAVE_TO_LIST',
  ENABLE_SAVE_TRIP_MENU: 'ENABLE_SAVE_TRIP_MENU',
  ENABLE_SEARCH_RESULTS_LOYALTY_DISCOUNTS: 'ENABLE_SEARCH_RESULTS_LOYALTY_DISCOUNTS',
  ENABLE_SINGLE_LEG_RESULTS_LEG_PINS: 'ENABLE_SINGLE_LEG_RESULTS_LEG_PINS',
  ENABLE_SINGLE_LEG_RESULTS_MULTI_STEP: 'ENABLE_SINGLE_LEG_RESULTS_MULTI_STEP',
  ENABLE_SONAR_ALPHA: 'ENABLE_SONAR_ALPHA',
  ENABLE_SPICY_HOMEPAGE_VIDEO_PLAYER: 'ENABLE_SPICY_HOMEPAGE_VIDEO_PLAYER',
  ENABLE_SPONSORED_BOOKING_PANEL_ACORN: 'ENABLE_SPONSORED_BOOKING_PANEL_ACORN',
  ENABLE_SPONSORED_BOOKING_PANEL_ADVERT: 'ENABLE_SPONSORED_BOOKING_PANEL_ADVERT',
  ENABLE_SPONSORED_BOOKING_PANEL_DESKTOP: 'ENABLE_SPONSORED_BOOKING_PANEL_DESKTOP',
  ENABLE_SPONSORED_DESTINATION_DAY_VIEW: 'ENABLE_SPONSORED_DESTINATION_DAY_VIEW',
  ENABLE_STAYS_NAVCARD: 'ENABLE_STAYS_NAVCARD',
  ENABLE_STREVDA_ADS_AFTER_GUIDEBOOK: 'ENABLE_STREVDA_ADS_AFTER_GUIDEBOOK',
  ENABLE_TCS: 'ENABLE_TCS',
  ENABLE_UPGRADE_MESSAGING_IN_SEARCH_RESULTS: 'ENABLE_UPGRADE_MESSAGING_IN_SEARCH_RESULTS',
  ENABLE_UPSELL_FARE_DIFFERENCE: 'ENABLE_UPSELL_FARE_DIFFERENCE',
  ENABLE_US_BELARUS_BANNER: 'ENABLE_US_BELARUS_BANNER',
  ENABLE_VERTICALS_ORDERING: 'ENABLE_VERTICALS_ORDERING',
  ENABLE_WEB_TO_APP_BANNERS: 'ENABLE_WEB_TO_APP_BANNERS',
  ENABLE_WEB_TO_APP_BANNERS_BANANA: 'ENABLE_WEB_TO_APP_BANNERS_BANANA',
  FPS_DEGRADATION_SLOW_DOWN_POLLING: 'FPS_DEGRADATION_SLOW_DOWN_POLLING',
  HEADER_REDUCED_VERTICAL_SPACING: 'HEADER_REDUCED_VERTICAL_SPACING',
  HOMEPAGE_DROPS_ENABLED: 'HOMEPAGE_DROPS_ENABLED',
  HOMEPAGE_DROPS_UI_ENABLED: 'HOMEPAGE_DROPS_UI_ENABLED',
  HOMEPAGE_PARALLEL_SEARCH_CONSENT_ENABLED: 'HOMEPAGE_PARALLEL_SEARCH_CONSENT_ENABLED',
  HOTELS_HEADER_TAB_BUBBLE_ENABLED: 'HOTELS_HEADER_TAB_BUBBLE_ENABLED',
  HOTEL_REDIRECT_PRICE_CONSISTENCY: 'HOTEL_REDIRECT_PRICE_CONSISTENCY',
  IS_INTERNAL_TRAFFIC: 'IS_INTERNAL_TRAFFIC',
  IS_VALID_BROWSER_FOR_GOT: 'IS_VALID_BROWSER_FOR_GOT',
  NATIVE_BOTTOM_CAR_HIRE_XSELL: 'native_bottom_car_hire_xsell',
  NATIVE_BOTTOM_HOTELS_XSELL: 'native_bottom_hotels_xsell',
  OTA_LOGOS_IN_RESULTS: 'OTA_LOGOS_IN_RESULTS',
  PACKAGES_ENABLE_RTS: 'PACKAGES_ENABLE_RTS',
  PACKAGES_HEADER_TAB_ENABLED: 'PACKAGES_HEADER_TAB_ENABLED',
  PACKAGES_HEADER_TAB_ENABLED_DESKTOP: 'PACKAGES_HEADER_TAB_ENABLED_DESKTOP',
  PACKAGES_PARALLEL_SEARCH_DEFAULT_VALUE: 'PACKAGES_PARALLEL_SEARCH_DEFAULT_VALUE',
  PARALLEL_SEARCH_DEFAULT_VALUE: 'PARALLEL_SEARCH_DEFAULT_VALUE',
  PARALLEL_SEARCH_OPTION_POSITION: 'PARALLEL_SEARCH_OPTION_POSITION',
  PARALLEL_SEARCH_REDIRECT_BEHAVIOUR: 'PARALLEL_SEARCH_REDIRECT_BEHAVIOUR',
  PAYMENT_DISCOUNT_INDIA_PHASE_2: 'PAYMENT_DISCOUNT_INDIA_PHASE_2',
  PAYMENT_DISCOUNT_KOREA_PHASE_2: 'PAYMENT_DISCOUNT_KOREA_PHASE_2',
  POC_PERSIST_REFERRER: 'POC_PERSIST_REFERRER',
  PRE_KONDO_BOOKING_PANEL_LOADING: 'PRE_KONDO_BOOKING_PANEL_LOADING',
  PRICE_ALERTS_ENABLED: 'PRICE_ALERTS_ENABLED',
  PRICE_PULSE_ENABLED: 'PRICE_PULSE_ENABLED',
  PRICE_PULSE_UI_ENABLED: 'PRICE_PULSE_UI_ENABLED',
  PRIMARY_NAV_IN_FSS: 'PRIMARY_NAV_IN_FSS',
  RANK_EXPLAINABILITY_ML_ENABLED: 'RANK_EXPLAINABILITY_ML_ENABLED',
  RBB_COPY_UPDATE: 'RBB_COPY_UPDATE',
  RENDER_SPONSORED_BOOKING_PANEL_ADVERT: 'RENDER_SPONSORED_BOOKING_PANEL_ADVERT',
  S2L_BOOKING_PANEL_BOTTOM_SHEET_CTA_EXPERIMENT: 'S2L_BOOKING_PANEL_BOTTOM_SHEET_CTA_EXPERIMENT',
  SHOULD_AVOID_BANANA_RESULTS: 'SHOULD_AVOID_BANANA_RESULTS',
  SHOW_AIRLINE_TAG: 'SHOW_AIRLINE_TAG',
  SHOW_COMBINED_RESULTS_BOTTOM_GOOGLE_ADVERT: 'SHOW_COMBINED_RESULTS_BOTTOM_GOOGLE_ADVERT',
  SHOW_COMBINED_RESULTS_CAR_HIRE: 'SHOW_COMBINED_RESULTS_CAR_HIRE',
  SHOW_COMBINED_RESULTS_HOTELS: 'SHOW_COMBINED_RESULTS_HOTELS',
  SHOW_DEBUG_CONTROLS: 'SHOW_DEBUG_CONTROLS',
  SHOW_ECO_FILTER: 'SHOW_ECO_FILTER',
  SHOW_GOOGLE_INLINE_ADS: 'SHOW_GOOGLE_INLINE_ADS',
  SHOW_INLINE_ADS: 'SHOW_INLINE_ADS',
  SHOW_PACKAGES_BANNER: 'SHOW_PACKAGES_BANNER',
  SHOW_PARTNER_MESSAGES: 'SHOW_PARTNER_MESSAGES',
  SHOW_PQS_MODAL: 'SHOW_PQS_MODAL',
  SHOW_PQS_NUMERICAL_RATING: 'show_pqs_numerical_rating',
  SHOW_PQS_SCORE: 'SHOW_PQS_SCORE',
  SHOW_PQS_SURVEY_ON_ACORN: 'SHOW_PQS_SURVEY_ON_ACORN',
  SHOW_PRICE_GRID: 'SHOW_PRICE_GRID',
  SHOW_SPONSORED_BOOKING_PANEL_DESKTOP: 'SHOW_SPONSORED_BOOKING_PANEL_DESKTOP',
  SHOW_UNPRICED_OPTION: 'SHOW_UNPRICED_OPTION',
  SKIP_ACCOMMODATION_CARHIRE_FROM_RADAR: 'SKIP_ACCOMMODATION_CARHIRE_FROM_RADAR',
  SPONSORED_AIRLINES_DRAWER_ENABLED: 'SPONSORED_AIRLINES_DRAWER_ENABLED',
  SPONSORED_AIRLINES_V2_DIRECT_BOOKING_PANEL: 'SPONSORED_AIRLINES_V2_DIRECT_BOOKING_PANEL',
  SPONSORED_AIRLINES_V2_DISPLAY: 'SPONSORED_AIRLINES_V2_DISPLAY',
  SPONSORED_AIRLINES_V2_USE_CARRIER_ID_FILTER: 'SPONSORED_AIRLINES_V2_USE_CARRIER_ID_FILTER',
  SPONSORED_DESTINATION_V2_DISPLAY: 'SPONSORED_DESTINATION_V2_DISPLAY',
  STAYS_COPY_HEADER_TAB_ENABLED: 'STAYS_COPY_HEADER_TAB_ENABLED',
  STREVDA_RUNTIME_REREQUEST_ENABLED: 'STREVDA_RUNTIME_REREQUEST_ENABLED',
  SUMMARY_ON_BP_BANANA_ENABLED: 'SUMMARY_ON_BP_BANANA_ENABLED',
  SWAP_PLACEDISPLAYCODE_AND_PLACENAME_BOOKING_PANEL:
    'SWAP_PLACEDISPLAYCODE_AND_PLACENAME_BOOKING_PANEL',
  SYNC_EVENTS_MAP_AND_LIST: 'SYNC_EVENTS_MAP_AND_LIST',
  USE_ACCOMMODATION_RESULTS_IN_SAM_NATIVE_BOTTOM_HOTELS_XSELL:
    'use_accommodation_results_in_sam_bottom_hotels_xsell',
  USE_ITINERARY_TOKEN: 'USE_ITINERARY_TOKEN',
  USE_NEW_TRACKING_ENDPOINT: 'use_new_tracking_endpoint',
  WHOLE_CARD_CLICKABLE: 'WHOLE_CARD_CLICKABLE',
  XSELL_BOOKING_PANEL_LOADING: 'xsell_booking_panel_loading',
} as const;
